import { SET_PROMO_PARAMS } from '../app-communication/actions/from-client-frontend';

export const initialState = {
  currency: null,
  promo: null,
  popup: null,
  serviceCompanyId: null
};

export const salesPromotionReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_PROMO_PARAMS:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};
